import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from '../../../../../global/global.service';
import {SavedListingFiltersEffects} from '../../store/saved-filters.effects';
import {ISaveNewFilter} from '../saved-filters/saved-filters.component';

@Component({
  selector: 'app-save-filter',
  templateUrl: './save-filter.component.html',
  styleUrl: './save-filter.component.scss'
})
export class SaveFilterComponent {
    readonly minimalNameLength = 5;
    @Input() saveFilterInProgress:boolean = false;
    @Input() isLoading: boolean = false;
    @Output() saveFilter: EventEmitter<ISaveNewFilter> = new EventEmitter();


    newFilterForm = this._formBuilder.group({
        public: [false, Validators.required],
        name: ['', [Validators.required, Validators.minLength(this.minimalNameLength)]],
    });

    constructor(public modal: NgbActiveModal,
                private _formBuilder: FormBuilder,
                private _savedListingFiltersEffects:SavedListingFiltersEffects,
                public globalService: GlobalService) {
    }

    onAddFilterClick(): void {

        this.newFilterForm.markAsTouched();
        if (this.newFilterForm.valid) {
            this.saveFilter.next({
                public: this.newFilterForm.value.public,
                name: this.newFilterForm.value.name
            });
        }
    }
 
}
